import { Field } from "formik";
import get from "lodash/get";
import { EMPTY_STRING } from "../../../constants";

const ExpressionField = ({
  name,
  values,
  handleChange,
  handleFunctionalExpression,
  expressionKey,
  serviceExpressionIcon,
  className = EMPTY_STRING,
}) => (
  <div className="flex flex-col rounded bg-white text-black mb-2">
    <div className="text-sm font-semibold border-b-2 px-2 py-1 border-gray-500">
      {name}
    </div>
    <div className="flex">
      <button
        type="button"
        className="hover:bg-gray-200 cursor-pointer disabled:cursor-not-allowed flex disabled:bg-gray-300"
        onClick={handleFunctionalExpression}
      >
        <img
          src={serviceExpressionIcon}
          alt="formula Icon"
          className="px-1 h-7 m-auto rounded-md"
        />
      </button>
      <Field
        as="textarea"
        onChange={handleChange}
        name={expressionKey}
        value={get(values, expressionKey)}
        className={`${className} form-control h-20 text-sm resize-none border-none focus:ring-transparent disabled:bg-gray-300 disabled:rounded-none`}
      />
    </div>
  </div>
);

export default ExpressionField;
